import { ZfDialog, ZfDialogContent, ZfDialogFooter, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    messageKey: string;
    onClose: () => void;
}

export const MessageModal: FunctionComponent<IProps> = ({ messageKey, onClose: onModalClose }) => {
    const { t } = useTranslation();
    const [isOpen, setOpen] = useState(true);
    const onClose = () => {
        setOpen(false);
        onModalClose();
    };

    return (
        <ZfDialog show={isOpen} size="s">
            <ZfDialogContent>
                <div>{t(messageKey)}</div>
            </ZfDialogContent>
            <ZfDialogFooter>
                <ZfTextButton slot="primary" size="medium" onClick={onClose}>
                    {t('modalCloseButton')}
                </ZfTextButton>
            </ZfDialogFooter>
        </ZfDialog>
    );
};
